import { createFileRoute, redirect } from "@tanstack/react-router";

/** Old URL — now the Mobile Auto Repair service page. */
export const Route = createFileRoute("/automotive-repair")({
  beforeLoad: () => {
    throw redirect({ to: "/services/$slug", params: { slug: "mobile-auto-repair" }, statusCode: 301 });
  },
});
